import sectionFreestyleCss from '../css-snippets/section-freestyle';

const html = `
<style>${sectionFreestyleCss}</style>
<div
  data-attribute="wrap-content"
  data-top-padding="true"
  data-bottom-padding="true"
  data-layout-full-width="false"
  data-spacing-horizontal="true"
>
  <div class="container" data-attribute="content">
    <figure class="image">
      <img
        src="https://cdn.cacheimg.com/Admin-Lattehub/2025/08/11/image-6899c09084df1fc10805ec51.webp?w=1000"
      />
    </figure>
  </div>
</div>

`;
export default html;
